module.exports = __webpack_public_path__ + "static/media/Location-black.f111bf6c.svg";